export const appDownloadEvent = {
  open: 'app_download_modal_view',
  linkClick: 'app_download_modal_link_click',
} as const;

export interface AppDownloadDataType {
  [appDownloadEvent.linkClick]: { app_link: string };
}
